import React, { useEffect, useState } from 'react';
import SearchField from '@amzn/meridian/search-field';
import useOnDebounce from 'src/hooks/useOnDebounce';
import { Optional } from 'src/types/utilities';

// **** Types **** //

type SearchFieldProps = React.ComponentProps<typeof SearchField>;

interface DebounceSearchFieldProps extends Optional<SearchFieldProps, 'onChange' | 'onSubmit'> {
  value: string;
  onDebounce: (value: string) => void;
  debounceMs?: number;
}

// **** Components **** //

/**
 * Default component
 */
const DebounceSearchField = (props: DebounceSearchFieldProps) => {
  const {
    value: propsValue,
    onDebounce,
    onChange = () => ({}),
    onSubmit = () => ({}),
    debounceMs,
    ...otherProps
  } = props;

  // State
  const [value, setValue] = useState('');

  // Listen for changes from the parent
  useEffect(() => {
    if (propsValue !== value) {
      setValue(propsValue);
    }
  }, [propsValue]);

  // Send search value to redux
  useOnDebounce(
    (v) => onDebounce(v),
    value,
    debounceMs,
    () => value === propsValue,
  );

  return (
    <SearchField
      value={value}
      onChange={(v) => {
        setValue(v);
        onChange(v);
      }}
      placeholder="Search for..."
      onSubmit={onSubmit}
      {...otherProps}
    />
  );
};

// **** Export **** //

export default DebounceSearchField;
